import {AOperationWithEquipment} from "./AOperationWithEquipment";
import {AElement} from "../elements/AElement";
import GPSCoordinates from "../GPSCoordinates";
import {EOperationType} from "../utils/EOperationType";
import {Icon} from "../Icon";
import MarkerIconService from "../../services/map/MarkerIconService";
import {CSS_CLASS_NAME_GRAY_MARKER, CSS_CLASS_NAME_ORANGE_MARKER} from "../../services/UtilsService";
import RemapService from "../../services/RemapService";

export class InstallationElement extends AOperationWithEquipment {

    private _newElement: AElement | undefined;

    constructor(
        id: string,
        idUser: string,
        date: Date,
        equipmentId?: string,
        newElement?: AElement,
        geolocation?: GPSCoordinates,
        isSynchro?: boolean,
        commentary?: string
    ) {
        const icon = new Icon(MarkerIconService.OPERATION_INSTALLATION_ELEMENT_ICON_PATH, MarkerIconService.generateIcon(MarkerIconService.OPERATION_INSTALLATION_ELEMENT_ICON_PATH, isSynchro ? CSS_CLASS_NAME_ORANGE_MARKER : CSS_CLASS_NAME_GRAY_MARKER));
        super(id, idUser, EOperationType.InstallationElement, date, icon, geolocation, isSynchro, commentary, equipmentId);
        this._newElement = newElement;
    }

    get newElement(): AElement | undefined {
        return this._newElement;
    }

    set newElement(value: AElement | undefined) {
        this._newElement = value;
    }

    public static remapObjectToOperation(object: any): InstallationElement | null {
        let operation: InstallationElement | null = null;
        if(
            object._id &&
            object._idUser &&
            object._date &&
            object._geolocation &&
            object._equipmentId &&
            object._newElement
        ) {
            const location = GPSCoordinates.remapObjectToGPSCoordinate(object._geolocation);
            const newElement = RemapService.remapObjectToElement(object._newElement);
            if(location && newElement) {
                operation = new InstallationElement(
                    object._id,
                    object._idUser,
                    object._date,
                    object._equipmentId,
                    newElement,
                    location,
                    object._isSynchro,
                    object._commentary
                );
            }
        }
        return operation;
    }

    isCorrect(): boolean {
        return (
            super.isCorrect() &&
            this.newElement !== undefined &&
            this.newElement.isCorrect()
        );
    }
}
